import {Injectable} from '@angular/core';
import {ALL_ID, SessionArrayType, SessionObject, SessionValueType} from '@twpub/core/models';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  constructor(private router: Router) {
  }

  private createUrl(resultPage: boolean, conceptId?: number, termId?: number) {
    const prefix = resultPage ? 'result' : 'dict';
    // if (!dictId) {
    //   return '';
    // }
    return prefix + (conceptId ? `/${conceptId}` : '') + (termId ? `/${termId}` : '');
  }

  /**
   * Constructs a URL from a SessionObject.
   * - The route is built using dictId, conceptId and termId.
   * - The query parameters include sourceLang, targetLangs, searchTerm, sectionOids and domainIds.
   */
  public updateUrlFromSession(session: SessionObject): string {
    const routeUrl = this.createUrl(session.isResultPage!, session.conceptId, session.termId);
    const queryParams: { [key: string]: string | null } = {};

    const addQueryArray = (qProp: string, sProp: SessionArrayType) => {
      const prop = session[sProp];
      queryParams[qProp] = !prop?.length ? ALL_ID : prop.join(',');
    }
    const addQueryValue = (qProp: string, sProp: SessionValueType) => {
      const prop = session[sProp]?.toString();
      queryParams[qProp] = !prop?.length ? null : prop;
    }
    addQueryArray('dict', 'dictIds');
    addQueryArray('lang', 'sourceLangs');
    addQueryArray('target', 'targetLangs');
    addQueryArray('section', 'sectionOids');
    addQueryArray('domain', 'domainIds');

    addQueryValue('term', 'searchTerm');

    if (!session.isResultPage) {
      const queryString = Object.entries(queryParams)
        .filter(([_, value]) => value !== null)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value!)}`)
        .join('&');

      const url = queryString ? `${routeUrl}?${queryString}` : routeUrl;
      this.replaceState(url);
      return url;
    } else {
      const filteredQueryParams = Object.fromEntries(
        Object.entries(queryParams).filter(([_, value]) => value !== null)
      );

      this.router.navigate([routeUrl], {
        queryParams: filteredQueryParams,
        replaceUrl: false
      });
    }
    return '';
  }

  public replaceState(url: string) {
    window.history.pushState({}, '', url);
  }
}
